import axios from 'axios';
import Cookies from "js-cookie";
import { toast } from 'react-toastify';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

instance.interceptors.request.use(config => {
  const token = Cookies.get(process.env.REACT_APP_AUTH_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

instance.interceptors.response.use(function (response) {
    if(response?.data?.error_code === 401){
      Cookies.remove(process.env.REACT_APP_AUTH_KEY);
      
      window.dispatchEvent(new CustomEvent('logout'));
      
      return response;
    }
    if(response?.data?.code === 1 && response?.data?.messages){
      let results = typeof response?.data?.messages === 'object' ? Object.values(response?.data?.messages) : response?.data?.messages 
      for(let i of results){
        for(let j of i){
          toast.error(j)
        }
      }
    }
    return response;
  }, function (error) {
    
  });
  
export default instance;